import { ArmchairIcon, BellIcon, Building2Icon, CalendarIcon, GroupIcon, HomeIcon, LayersIcon, LifeBuoyIcon, MapIcon, PresentationIcon, ScanQrCodeIcon, ScrollTextIcon, SettingsIcon, UserIcon } from 'lucide-react';
import * as Pages from '../app/pages';
import { STATIC_USER_ROLES, STATIC_USER_ROLES_ENUM } from '../utils/enums';
import BellNewIcon from '../components/bell-new-icon';
import { RouteGroups, URLS } from './urls';

export { RouteGroups, URLS };

export const ProtectedRoutes = [
    {
        id: 'FX1',
        priority: 1,
        path: URLS.ADMIN.ROOT,
        page: Pages.Home,
        isPrivate: true,
        inSideBarList: true,
        name: 'Home',
        icon: <HomeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX2',
        priority: 2,
        path: URLS.ADMIN.HOME,
        page: Pages.Home,
        isPrivate: true,
        inSideBarList: false,
        name: 'Home',
        icon: <HomeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX3',
        path: URLS.ADMIN.AUTH,
        page: Pages.Auth,
        isPrivate: false,
        inSideBarList: false,
        name: 'Login',
        permissibleRoles: STATIC_USER_ROLES_ENUM,
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX3-5',
        priority: 3,
        path: URLS.ADMIN.MANAGEMENT,
        page: Pages.Management,
        isPrivate: true,
        inSideBarList: true,
        name: 'Management',
        icon: <MapIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
        nestedRoutes: [
            {
                id: 'FX3-5-1',
                path: `/:branchId`,
                page: Pages.ManagementBranchCampus,
                isPrivate: true,
                inSideBarList: false,
                name: 'Branch Campus',
                icon: <Building2Icon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                availableOperations: ['C', 'R', 'U', 'D'],
                nestedRoutes: [
                    {
                        id: 'FX3-5-2',
                        path: `/:buildingId`,
                        page: Pages.ManagementBuildingFloors,
                        isPrivate: true,
                        inSideBarList: false,
                        name: 'Building Floors',
                        icon: <LayersIcon size={12} />,
                        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                        availableOperations: ['C', 'R', 'U', 'D'],
                        nestedRoutes: [
                            {
                                id: 'FX3-5-3',
                                path: `/:floorId`,
                                page: Pages.ManagementFloorPlanView,
                                isPrivate: true,
                                inSideBarList: false,
                                name: 'Floor Plan',
                                icon: <MapIcon size={12} />,
                                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                                availableOperations: ['R'],
                                nestedRoutes: [
                                    {
                                        id: 'FX3-5-3-1',
                                        path: `/edit`,
                                        page: Pages.ManagementFloorPlanEdit,
                                        isPrivate: true,
                                        inSideBarList: false,
                                        name: 'Edit Floor Plan',
                                        icon: <MapIcon size={12} />,
                                        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                                        availableOperations: ['C', 'R', 'U', 'D'],
                                    },
                                    {
                                        id: 'FX3-5-3-2',
                                        path: `/history`,
                                        page: Pages.ManagementFloorPlanHistory,
                                        isPrivate: true,
                                        inSideBarList: false,
                                        name: 'Floor Plan History',
                                        icon: <MapIcon size={12} />,
                                        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                                        availableOperations: ['R'],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        id: 'FX7',
        path: URLS.ADMIN.OFFICE,
        page: Pages.Office,
        isPrivate: true,
        inSideBarList: false,
        name: 'Private Offices',
        icon: <ScanQrCodeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: RouteGroups.MANAGEMENT,
    },
    {
        id: 'FX10',
        path: URLS.ADMIN.SEAT,
        page: Pages.Seat,
        isPrivate: true,
        inSideBarList: false,
        name: 'Seats',
        icon: <ArmchairIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: RouteGroups.MANAGEMENT,
        nestedRoutes: [
            {
                id: 'FX10-1',
                path: `/:seatId`,
                page: Pages.SeatDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'Seat Details',
                icon: <ArmchairIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                availableOperations: ['R']
            }
        ]
    },
    {
        id: 'FX7-1',
        path: URLS.ADMIN.NOTIFICATIONS,
        page: Pages.Notifications,
        isPrivate: true,
        inSideBarList: true,
        name: 'Notifications',
        icon: <BellIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['R', 'U'],
        group: null,
    },
    {
        id: 'FX8',
        path: URLS.ADMIN.MEETING_ROOM,
        page: Pages.MeetingRoom,
        isPrivate: true,
        inSideBarList: true,
        name: 'Meeting Rooms',
        icon: <PresentationIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
    },
    {
        id: 'FX11',
        path: URLS.ADMIN.LEAD,
        page: Pages.Lead,
        isPrivate: true,
        inSideBarList: true,
        name: 'Leads',
        icon: <UserIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER, STATIC_USER_ROLES.RECEPTIONIST],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
    },
    {
        id: 'FX12',
        path: URLS.ADMIN.CUSTOMER,
        page: Pages.Customer,
        isPrivate: true,
        inSideBarList: true,
        name: 'Customers',
        icon: <UserIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
        nestedRoutes: [
            {
                id: 'FX12-1',
                path: `/:customerId`,
                page: Pages.CustomerDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'Customer Details',
                icon: <UserIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                availableOperations: ['R', 'create_contract', 'read_contract'],
                nestedRoutes: [
                    {
                        id: 'FX12-1-1',
                        path: '/team-member/:teamMemberId',
                        page: Pages.TeamMemberDetail,
                        isPrivate: true,
                        inSideBarList: false,
                        name: 'Team Member Details',
                        icon: <UserIcon size={12} />,
                        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                        availableOperations: ['R']
                    },
                    {
                        id: 'FX12-1-2',
                        path: '/booking/:bookingId',
                        page: Pages.BookingDetail,
                        isPrivate: true,
                        inSideBarList: false,
                        name: 'Booking Details',
                        icon: <CalendarIcon size={12} />,
                        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                        availableOperations: ['R']
                    }
                ]
            }
        ]
    },
    {
        id: 'FX13',
        path: URLS.ADMIN.CONTRACTS,
        page: Pages.Contract,
        isPrivate: true,
        inSideBarList: true,
        name: 'Contracts',
        icon: <ScrollTextIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'D'],
        group: null,
    },
    {
        id: 'FX14',
        path: URLS.ADMIN.USER,
        page: Pages.User,
        isPrivate: true,
        inSideBarList: true,
        name: 'Users',
        icon: <UserIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
        nestedRoutes: [
            {
                id: 'FX14-1',
                path: `/:userId`,
                page: Pages.UserDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'User Details',
                icon: <UserIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                availableOperations: ['R']
            }
        ]
    },
    {
        id: 'FX15',
        path: URLS.ADMIN.USER_GROUPS,
        page: Pages.UserGroups,
        isPrivate: true,
        inSideBarList: true,
        name: 'User Groups',
        icon: <GroupIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['C', 'R', 'U', 'D'],
        group: null,
        nestedRoutes: [
            {
                id: 'FX15-1',
                path: `/:userGroupId`,
                page: Pages.UserGroupDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'User Group Details',
                icon: <GroupIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
                availableOperations: ['R']
            }
        ]
    },
    {
        id: 'FX16',
        path: URLS.CUSTOMER.HOME,
        page: Pages.CustomerHome,
        isPrivate: true,
        inSideBarList: true,
        name: 'Home',
        icon: <HomeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.USER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX17',
        path: URLS.CUSTOMER.PROFILE,
        page: Pages.CustomerProfile,
        isPrivate: true,
        inSideBarList: true,
        name: 'Profile',
        icon: <UserIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.USER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX17',
        path: URLS.CUSTOMER.MEETING_ROOM,
        page: Pages.CustomerMeetingRoom,
        isPrivate: true,
        inSideBarList: true,
        name: 'Meeting Rooms',
        icon: <PresentationIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.USER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX18',
        path: URLS.CUSTOMER.CONTRACT,
        page: Pages.CustomerContract,
        isPrivate: true,
        inSideBarList: true,
        name: 'Contracts',
        icon: <ScrollTextIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.USER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX18-1',
        path: URLS.CUSTOMER.SUPPORT,
        page: Pages.CustomerSupport,
        isPrivate: true,
        inSideBarList: true,
        name: 'Support',
        icon: <LifeBuoyIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.USER], // TODO: Remove this once we have a proper auth system
        availableOperations: ['R', 'C'],
        // Use a "new" badge/icon to indicate this is a new feature
        secondaryIcon: <BellNewIcon />,
        nestedRoutes: [
            {
                id: 'FX18-1-1',
                path: `/create`,
                page: Pages.CustomerSupportCrudForm,
                isPrivate: true,
                inSideBarList: false,
                name: 'Create Ticket',
                icon: <LifeBuoyIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.USER], // TODO: Remove this once we have a proper auth system
                availableOperations: ['C']
            },
            {
                id: 'FX18-1-2',
                path: `/:ticketId`,
                page: Pages.CustomerSupportDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'Ticket Details',
                icon: <LifeBuoyIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.USER], // TODO: Remove this once we have a proper auth system
                availableOperations: ['R']
            }
        ]
    },
    {
        id: 'FX19',
        path: URLS.TEAM_MEMBER.HOME,
        page: Pages.TeamMemberHome,
        isPrivate: true,
        inSideBarList: true,
        name: 'Home',
        icon: <HomeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.TEAM_MEMBER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX20',
        path: URLS.TEAM_MEMBER.MEETING_ROOM,
        page: Pages.TeamMemberMeetingRoom,
        isPrivate: true,
        inSideBarList: true,
        name: 'Meeting Rooms',
        icon: <PresentationIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.TEAM_MEMBER],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX21',
        path: URLS.ADMIN.SUPPORT,
        page: Pages.Support,
        isPrivate: true,
        inSideBarList: true,
        name: 'Support',
        icon: <LifeBuoyIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER, STATIC_USER_ROLES.RECEPTIONIST],
        availableOperations: ['R', 'C', 'U', 'D'],
        group: null,
        nestedRoutes: [
            {
                id: 'FX21-1',
                path: `/:ticketId`,
                page: Pages.SupportDetail,
                isPrivate: true,
                inSideBarList: false,
                name: 'Ticket Details',
                icon: <LifeBuoyIcon size={12} />,
                permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER, STATIC_USER_ROLES.RECEPTIONIST],
                availableOperations: ['R'],
            }
        ]
    },
    {
        id: 'FX22',
        path: URLS.ADMIN.SETTINGS,
        page: Pages.Settings,
        isPrivate: true,
        inSideBarList: true,
        name: 'Settings',
        icon: <SettingsIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.ADMIN, STATIC_USER_ROLES.SUPER_ADMIN, STATIC_USER_ROLES.MANAGER],
        availableOperations: ['R', 'U'],
        group: RouteGroups.PREFERENCES,
        // nestedRoutes: [
        //     {
        //         id: 'FX22-1',
        //         path: '/:settingId',
        //         page: Pages.SettingDetail,
        //         isPrivate: true,
        //         inSideBarList: false,
        //         name: 'Setting Details',
        //         icon: <SettingsIcon size={12} />,
        //     }
        // ]
    },
    {
        id: 'FX23',
        path: URLS.RECEPTIONIST.HOME,
        page: Pages.ReceptionistHome,
        isPrivate: true,
        inSideBarList: true,
        name: 'Home',
        icon: <HomeIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
        availableOperations: ['R'],
        group: null,
    },
    {
        id: 'FX24',
        path: URLS.RECEPTIONIST.MEETING_ROOM,
        page: Pages.ReceptionistMeetingRoom,
        isPrivate: true,
        inSideBarList: true,
        name: 'Meeting Rooms',
        icon: <PresentationIcon size={16} />,
        permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
        group: null,
    },
    // {
    //     id: 'FX25',
    //     path: URLS.RECEPTIONIST.NOTIFICATIONS,
    //     page: Pages.ReceptionistNotifications,
    //     isPrivate: true,
    //     inSideBarList: true,
    //     name: 'Notifications',
    //     icon: <BellIcon size={16} />,
    //     permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
    //     group: null,
    // },
    // {
    //     id: 'FX26',
    //     path: URLS.RECEPTIONIST.PROFILE,
    //     page: Pages.ReceptionistProfile,
    //     isPrivate: true,
    //     inSideBarList: true,
    //     name: 'Profile',
    //     icon: <UserIcon size={16} />,
    //     permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
    //     group: null,
    // },
    // {
    //     id: 'FX27',
    //     path: URLS.RECEPTIONIST.SUPPORT,
    //     page: Pages.ReceptionistSupport,
    //     isPrivate: true,
    //     inSideBarList: true,
    //     name: 'Support',
    //     icon: <LifeBuoyIcon size={16} />,
    //     permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
    //     group: null,
    // },
    // {
    //     id: 'FX28',
    //     path: URLS.RECEPTIONIST.SETTINGS,
    //     page: Pages.ReceptionistSettings,
    //     isPrivate: true,
    //     inSideBarList: true,
    //     name: 'Settings',
    //     icon: <SettingsIcon size={16} />,
    //     permissibleRoles: [STATIC_USER_ROLES.RECEPTIONIST],
    // }
]